




















import { Component, Vue, Inject } from "vue-property-decorator";

import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";
import FormErrors from "@/lib/components/FormErrors.vue";

import ErrorConverterService from "@/modules/forms/error-converter.service";

import UserRepository from "../user.repository";

@Component({
  metaInfo: {
    title: "Login",
  },
  components: {
    FormErrors,
    LoadingSpinner,
  },
})
export default class LoginPage extends Vue {
  @Inject("ErrorConverterService")
  private fErrorConverterService!: ErrorConverterService;

  @Inject("UserRepository")
  private fUserRepository!: UserRepository;

  private fErrorsList: string[] = [];

  private fIsLoading = true;

  get errorsList(): string[] {
    return this.fErrorsList;
  }

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  public async created(): Promise<void> {
    try {
      const redirect = this.$auth.redirect();

      if (!redirect) {
        throw new Error("Login by direct link is not supported");
      }

      const token = redirect.from.query.token;

      if (!token) {
        throw new Error("Customer token not found");
      }

      await this.fUserRepository.loginByToken(token);

      await this.$router.replace(this.$auth.redirect().from.fullPath);
    } catch (e) {
      const errors = this.fErrorConverterService.describeError(e);
      this.fErrorsList.push(...errors);
    } finally {
      this.fIsLoading = false;
    }
  }
}
